import React from "react";

const styles = {
  margin: "50px 0 50px 0",
  display: "flex",
  float: "right",
  clear: "both",
};

const ButtonGroup = (props) => (
  <div style={styles} {...props}>
    {props.children}
  </div>
);

export default ButtonGroup;
